import { createAsyncThunk } from '@reduxjs/toolkit';
import CalendarService from '@/services/CalendarService';
import ContactsService from '@/services/ContactsService';
import DevelopmentsService from '@/services/DevelopmentsService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`AddFileModal/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getAddFileModalContacts = handler(
  'getContacts',
  ContactsService.getContacts
);

export const getAddFileModalProperties = handler(
  'getProperties',
  CalendarService.getProperties
);

export const getAddFileModalDevelopments = handler(
  'getDevelopments',
  DevelopmentsService.getCompanyDevelopments
);
